import React from "react";

import { Spinner } from "components/Icons/Spinner";
import { Card, Row, Col } from "reactstrap";

var Utils = require("Utils");
var Const = require("Const");

export const StudentEnrollCard = ({ student, studentHistory, loading }) => {
  return (
    <>
      {student && (
        <div>
          <Card
            className="card-user"
            style={{ backgroundColor: "rgb(236 234 234)", padding: "15px" }}
          >
            <Row>
              <Col md="4">
                <img
                  alt="..."
                  className="avatar border-gray"
                  src={
                    student.image
                      ? student.image
                      : Const.DEFAULT_IMAGE_PROFILE[
                          student.gender ? student.gender : "O"
                        ]
                  }
                />
              </Col>

              <Col className="pl-1" md="8">
                <p className="h5">
                  {" "}
                  {Utils.capitalize(
                    student.last_name + ", " + student.name
                  )}{" "}
                </p>
                <p className="h5">
                  {" "}
                  {student.doc_type + ": " + student.doc_nbr}{" "}
                </p>
                <h6>Matriculaciones previas {loading && <Spinner />}</h6>
                {studentHistory &&
                  studentHistory.map((hist) => {
                    return (
                      <Row key={hist.calendar_name}>
                        <Col md="12">
                          <p>{hist.calendar_name + " - " + hist.name} </p>
                        </Col>
                      </Row>
                    );
                  })}
              </Col>
            </Row>
          </Card>
        </div>
      )}
    </>
  );
};
